module.exports = __webpack_public_path__ + "img/5.3c2eae7d.png";